<template>
  <div class="add-variant">
    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Editar {{ variant.product ? variant.product.name : '' }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="form.valid">
            <v-row>
              <v-col cols="12">
                <br>
                <v-text-field
                  v-model="form.data.name"
                  :label="$t('products.modals.addVariant.name')"
                  :rules="form.rules.required"
                  type="text"
                  hide-details
                  dense
                  rounded
                  :disabled=true
                  outlined>
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.data.description"
                  :label="$t('products.modals.addVariant.description')"
                  type="text"
                  hide-details
                  dense
                  rounded
                  outlined
                />
              </v-col>
              <v-col cols="12">
               <v-text-field
                  :value="form.data.aliasesProvider[0]"
                  :label="$t('products.modals.addVariant.aliasesProvider')"
                  type="text"
                  hide-details
                  dense
                  disabled
                  rounded
                  outlined>
                  <template v-slot:append>
                      <v-tooltip
                        max-width="200"
                        left>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="secondary"
                            icon
                            x-small
                            depressed
                          >
                            <v-icon>mdi-information</v-icon>
                          </v-btn>
                        </template>
                        <ul>
                          <li v-for="(alias, index) in form.data.aliasesProvider" :key="index">
                            {{ alias }}
                          </li>
                        </ul>
                      </v-tooltip>
                  </template>
               </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="subtitle-1">
                  {{ $t('products.modals.addVariant.infoSubtitle')}}
                </p>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.data.brand"
                  :label="$t('products.modals.addVariant.brand')"
                  type="text"
                  hide-details
                  dense
                  rounded
                  outlined>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="d-flex justify-space-between">
                <div>
                  <v-text-field
                    disabled
                    v-model="form.data.satCode"
                    hide-details
                    required
                    rounded
                    outlined
                    dense
                    maxlength="8"
                    :rules="form.rules.satCode"
                    :label="$t('products.labels.satCode')"
                  />
                </div>
                <div>
                  <v-tooltip top>
                    <template
                      v-slot:activator="{ on }">
                        <v-icon
                          class="mt-1"
                          small
                          color="primary"
                          v-on="on"
                          @click="searchSatCodeDialog=true"
                        >
                          mdi-pencil
                        </v-icon>
                    </template>
                    <span>Editar SatCode</span>
                  </v-tooltip>
                </div>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.data.cost"
                  :label="$t('products.modals.addVariant.cost')"
                  :rules="form.rules.required"
                  prefix="$"
                  type="number"
                  hide-details
                  dense
                  rounded
                  outlined
                  @blur="updateCost"
                  >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.data.profit"
                  type="number"
                  dense
                  rounded
                  outlined
                  hide-details
                  prefix="%"
                  label="Porcentaje de ganancia"
                  @blur="updateAmount">
                  <template v-slot:append>
                    <v-tooltip
                      max-width="200"
                      left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          color="primary"
                          icon
                          x-small
                          depressed
                        >
                          <v-icon>mdi-help</v-icon>
                        </v-btn>
                      </template>
                      <span>
                        Si la factura es de un proveedor tuyo, le aumentas un porcentaje para tener una ganancia del precio que te vende tu proveedor.
                      </span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.data.amount"
                  :label="$t('products.modals.addVariant.price')"
                  :rules="form.rules.required"
                  prefix="$"
                  type="number"
                  hide-details
                  dense
                  rounded
                  outlined
                  @blur="updateProfit">
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.data.amountWithTaxes"
                  :loading="loader"
                  :label="$t('products.modals.addVariant.priceWithTaxes')"
                  prefix="$"
                  readonly
                  disabled
                  type="number"
                  hide-details
                  dense
                  rounded
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="tax"
                  dense
                  :items="searchTaxes.items"
                  @change="addTax($event)"
                  loading="Cargando impuestos"
                  :search-input.sync="searchTaxes.search"
                  return-object
                  outlined
                  rounded
                  color="primary"
                  hide-details
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="_id"
                  label="Impuestos"
                  placeholder="Nombre del impuesto"
                />
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="form.data.type"
                  :value="form.data.type"
                  :items="types"
                  item-value="value"
                  item-text="text"
                  label="Tipo"
                  hide-details
                  dense
                  rounded
                  outlined
                  />
              </v-col>
              <v-col cols="6" />
              <v-col cols="6">
                <draggable v-model="form.data.taxes"
                  group="taxes"
                  @end="calculateAmountWithTaxes"
                  v-if="form.data.taxes"
                 >
                  <div v-for="(element, index) in form.data.taxes" :key="element._id">
                    <div class="item">
                       <v-icon
                          small
                          color="primary"
                          class="mr-1"
                          >
                            mdi-drag
                          </v-icon>
                      <span class="mr-1">{{element.name}}</span>
                      <v-tooltip right>
                        <template
                          v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            depressed
                            color="error"
                            style="float: right"
                            @click="removeItem(index)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                          <span>Eliminar elemento</span>
                      </v-tooltip>
                     <v-tooltip right>
                        <template
                          v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            color="secondary"
                            small
                            depressed
                            style="float: right"
                            @click="updateTax(element.tax, index)"
                          >
                            mdi-autorenew
                          </v-icon>
                        </template>
                        <span>Actualizar impuesto</span>
                      </v-tooltip>
                    </div>
                  </div>
                </draggable>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="subtitle-1">
                  {{ $t('products.modals.addVariant.warehouseSubtitle')}}
                </p>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="form.data.displayUnit"
                  :label="$t('products.modals.addVariant.displayUnit')"
                  :rules="form.rules.required"
                  :items="units"
                  :filter="filterUnit"
                  item-text="name"
                  item-value="id"
                  hide-details
                  dense
                  rounded
                  outlined>
                  <template v-slot:append>
                    <v-tooltip
                      max-width="250"
                      open-delay="500"
                      close-delay="2000"
                      color="primary"
                      top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          color="primary"
                          x-small
                          depressed
                        >
                          <v-icon
                            small
                          >
                            mdi-help
                          </v-icon>
                        </v-btn>
                      </template>
                      <div>
                        La unidad de presentación debe ser una unidad válida por el SAT, esta unidad es con la que será facturada tu producto.<br>
                        Mas información aquí:<br>
                        <a class="primary-text" href="http://pys.sat.gob.mx/PyS/catUnidades.aspx" target="_blank" rel="noopener noreferrer">Catálogo de Unidades del SAT</a>
                      </div>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="6" />
              <v-col cols="6">
                <v-text-field
                  v-model="form.data.contentQuantity"
                  :label="$t('products.modals.addVariant.contentQuantity')"
                  :rules="form.rules.required"
                  type="number"
                  hide-details
                  dense
                  rounded
                  outlined>
                  <template v-slot:append>
                    <v-tooltip
                      max-width="250"
                      top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          color="primary"
                          x-small
                          depressed
                        >
                          <v-icon
                            small
                          >
                            mdi-help
                          </v-icon>
                        </v-btn>
                      </template>
                      <div>
                        La cantidad de contenido es cuanto tiene esa presentación que vendes, por ejemplo si es 1 Caja, pero contiene 10 paquetes.
                      </div>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="form.data.contentUnit"
                  :label="$t('products.modals.addVariant.contentUnit')"
                  :rules="form.rules.required"
                  :items="units"
                  :filter="filterUnit"
                  item-text="name"
                  item-value="id"
                  hide-details
                  dense
                  rounded
                  outlined>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="close">
            {{ $t('products.modals.addVariant.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            @click="submit">
            {{ $t('products.modals.addVariant.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      @keydown.esc="searchSatCodeDialog=false"
      v-model="searchSatCodeDialog"
      max-width="550px">
      <v-card>
        <v-card-title class="text-h5 primary white--text">
          Buscador de satcodes
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field
            class="ma-3"
            hide-details
            dense
            rounded
            outlined
            :value="form.data.satCode"
            append-icon="mdi-magnify"
            label="Satcode"
            @input="searchCode"
          />
          <v-data-table
            :loading="searchCodeSAT.isLoading"
            :items="searchCodeSAT.data"
            :headers="searchCodeSAT.headers"
            :server-items-length="searchCodeSAT.total"
            v-model="searchCodeSAT.selected"
            :options="searchCodeSAT.options"
            @input="setSatCode"
            class="elevation-1"
            show-select
            single-select
            item-key="key"
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            @click="closeSearchSatCodeDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            :disabled="searchCodeSAT.selected.length === 0"
            @click="closeSearchSatCodeDialog">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <PropagatePriceToOrders
      ref="propagatePriceToOrders"
      :allowPropagateToCatalog="false"
    />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'
import draggable from 'vuedraggable'
import PropagatePriceToOrders from '@/components/modals/PropagatePriceToOrders'
export default {
  props: {
    variant: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    draggable,
    PropagatePriceToOrders
  },
  data () {
    return {
      isOpen: false,
      overlay: false,
      prevPrice: 0,
      form: {
        valid: false,
        loading: false,
        data: {
          name: '',
          description: '',
          amount: 0,
          cost: 0,
          brand: '',
          displayQuantity: '',
          displayUnit: '',
          contentQuantity: '',
          contentUnit: '',
          yield: 100,
          profit: 10,
          satCode: null,
          amountWithTaxes: 0,
          taxes: [],
          type: '',
          aliasesProvider: []
        },
        rules: {
          required: [v => !!v || this.$t('validations.required')],
          satCode: [
            v => !!v || this.$t('validations.satCode.required'),
            v => (v && v.length === 8) || 'El satCode debe de ser de 8 carácteres'
          ]
        }
      },
      loader: false,
      tax: '',
      searchSatCodeDialog: false,
      searchTaxes: {
        search: '',
        selected: null,
        items: [],
        isLoading: false
      },
      searchCodeSAT: {
        search: '',
        headers: [
          { text: 'Satcode', value: 'key', sortable: false },
          { text: 'Descripción', value: 'description', sortable: false }
        ],
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: ['name'],
          sortDesc: []
        },
        selected: [],
        data: [],
        total: 0,
        isLoading: false
      },
      types: [{ value: 'product', text: 'Producto' }, { value: 'service', text: 'Servicio' }]
    }
  },
  watch: {
    isOpen (val) {
      if (val && (this.variant || {})._id) {
        const variant = cloneDeep(this.variant)
        const taxes = variant.taxes.filter(x => x.tax)
        this.prevPrice = variant.amount
        this.form.data = {
          name: variant.product.name,
          description: variant.description,
          cost: variant.amountInvoice,
          amount: variant.amount,
          brand: variant.brand,
          displayUnit: variant.displayUnit && variant.displayUnit._id ? variant.displayUnit._id : variant.displayUnit,
          contentQuantity: variant.contentQuantity,
          contentUnit: variant.contentUnit && variant.contentUnit._id ? variant.contentUnit._id : variant.contentUnit,
          yield: 100,
          profit: this.calculatePercentage(variant.amount, variant.amountInvoice),
          satCode: variant.satCode,
          taxes: taxes,
          type: variant.product.type,
          aliasesProvider: variant.aliasesProvider || []
        }
        if (taxes.length) {
          this.calculateAmountWithTaxes()
        } else {
          this.form.data.amountWithTaxes = 0
        }
      }
    },
    'searchTaxes.search': debounce(async function (val) {
      if (val && val.length >= 3) {
        this.searchTaxes.isLoading = true
        const params = { name: `/${val}/i` }
        try {
          const res = await this.$api.get(`/v1/providers/${this.$store.state.currentProvider.data._id}/taxes`, params)
          this.searchTaxes.items = res.data
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.searchTaxes.isLoading = false
      }
    }, 600)
  },
  computed: {
    units () {
      return this.$store.state.login.units.data
    },
    provider () {
      return this.$store.state.currentProvider.data._id
    },
    test (param) {
      return param.join(',')
    }
  },
  methods: {
    closeSearchSatCodeDialog () {
      this.searchCodeSAT.data = []
      this.searchSatCodeDialog = false
    },
    searchCode: debounce(async function (val) {
      if (val && val.length >= 3) {
        this.searchCodeSAT.isLoading = true
        try {
          const res = await this.$api.get(`/v1/catalog/sat/search/satcode`, { q: val })
          this.searchCodeSAT.data = res
          this.searchCodeSAT.total = res.length
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.searchCodeSAT.isLoading = false
      } else {
        this.searchCodeSAT.data = []
      }
    }, 600),
    setSatCode (item) {
      if (item) {
        this.form.data.satCode = item[0].key
      } else {
        this.searchCodeSAT.data = []
      }
    },
    open () {
      this.isOpen = true
    },
    close () {
      this.$emit('update')
      this.reset()
      this.isOpen = false
    },
    async submit () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        try {
          const price = await this.$api.put(`/v1/catalog/${this.variant._id}`, this.form.data)
          if (this.prevPrice !== price.amount) {
            const payload = {
              name: this.variant.product.name,
              choice: this.variant._id,
              product: this.variant.product._id,
              amount: price.amount
            }
            this.$refs.propagatePriceToOrders.open(payload, null, true)
          }
          this.$toasted.show(`Se actualizó el producto: ${this.form.data.name} exitosamente.`, { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
          this.$emit('update')
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
        }
        this.overlay = false
        this.close()
      }
    },
    reset () {
      this.form.data = {
        name: '',
        description: '',
        amount: 0,
        cost: 0,
        brand: '',
        displayQuantity: '',
        displayUnit: '',
        contentQuantity: '',
        contentUnit: '',
        yield: 100,
        profit: 0,
        satCode: '',
        amountWithTaxes: 0,
        taxes: [],
        type: '',
        aliasesProvider: []
      }
      this.loader = false
      this.tax = ''
      this.$refs.form.resetValidation()
    },
    filterUnit (item, queryText, itemText) {
      const a = new RegExp(queryText, 'gi')
      if (a.test(itemText)) {
        return item
      }
    },
    calculateAmount (amount, profit) {
      const rate = (profit || 0) / 100
      const price = amount + (amount * rate)
      return Number(price).toFixed(2)
    },
    updateAmount (event) {
      const amount = this.calculateAmount(Number(this.form.data.cost), Number(event.target.value))
      this.form.data.amount = amount
      this.calculateAmountWithTaxes()
    },
    calculatePercentage (price, amount) {
      const profit = price - amount
      const percentage = (profit * 100) / amount
      return Number(percentage).toFixed(2)
    },
    updateProfit (event) {
      const profit = this.calculatePercentage(Number(event.target.value), Number(this.form.data.cost))
      this.form.data.profit = profit
      this.calculateAmountWithTaxes()
    },
    calculateCost (amount, profit) {
      const rate = (profit || 0) / 100
      const price = amount + (amount * rate)
      return Number(price).toFixed(2)
    },
    updateCost (event) {
      const amount = this.calculateCost(Number(event.target.value), this.form.data.profit)
      this.form.data.amount = amount
    },
    addTax (tax) {
      if (tax) {
        this.form.data.taxes.push(tax)
        this.calculateAmountWithTaxes()
        this.$nextTick(() => {
          this.tax = ''
        })
      }
    },
    removeItem (item) {
      this.form.data.taxes.splice(item, 1)
      this.calculateAmountWithTaxes()
    },
    async calculateAmountWithTaxes () {
      this.loader = true
      try {
        if (this.form.data.taxes.length) {
          const response = await this.$api.post(`/v1/catalog/${this.variant._id}/taxes/total`, { amount: this.form.data.amount, taxes: this.form.data.taxes })
          this.form.data.amountWithTaxes = response
        } else {
          this.form.data.amountWithTaxes = 0
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loader = false
    },
    async updateTax (item, index) {
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/providers/${this.provider}/taxes`, { _id: item })
        this.form.data.taxes[index].name = response.data[0].name
        this.form.data.taxes[index].kind = response.data[0].kind
        this.form.data.taxes[index].satCode = response.data[0].satCode
        this.form.data.taxes[index].isQuota = response.data[0].isQuota
        this.form.data.taxes[index].isRetention = response.data[0].isRetention
        this.form.data.taxes[index].base = response.data[0].base
        await this.$api.put(`/v1/catalog/${this.variant._id}/tax`, { taxes: this.form.data.taxes, amount: this.form.data.amount })
        this.calculateAmountWithTaxes()
        this.$toasted.show('El impuesto del producto  se actualizo correctamente', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  margin: 1px;
  padding: 10px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
  background: #f4f3f3;
  display: inline-block;
  width: 100%;
}
</style>
